import { Button, Grid, Paper } from "@mui/material";
import EditFormControl from "components/form/EditFormControl";
import LabelControl from "components/form/LabelControl";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { ERR_VALIDATION_TEXT } from "constants/messages";
import { updateCoupon } from "models/couponcodeModel";
import { createCoupon } from "models/couponcodeModel";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { openLoading } from "store/reducers/tools";
import CouponDetailForm from "./CouponDetailForm";

export default function CouponDetailComponent({
  couponInfo = {},
  couponId = "",
}) {
  const formRef = useRef();
  const [data, setData] = useState({});
  const [error, setError] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const errorAction = (res, err) => {
    if (!res && err?.message) {
      enqueueSnackbar(err?.message, { variant: "warning" });
    } else {
      enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name" && Boolean(value)) {
      setError((s = {}) => ({ ...s, name: "" }));
    }
    if (name === "code" && Boolean(value)) {
      setError((s = {}) => ({ ...s, code: "" }));
    }
    if (name === "amount" && Boolean(value)) {
      setError((s = {}) => ({ ...s, code: "" }));
    }
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClickAdd = () => {
    const submitData = formRef.current?.prepare();
    if (!Boolean(data?.name)) {
      setError((s = {}) => ({ ...s, name: ERR_VALIDATION_TEXT.LONG }));
    }
    if (!Boolean(data?.code)) {
      setError((s = {}) => ({ ...s, code: ERR_VALIDATION_TEXT.LONG }));
    }
    if (!Boolean(data?.amount)) {
      setError((s = {}) => ({ ...s, amount: ERR_VALIDATION_TEXT.LONG }));
    }
    if (submitData) {
      openLoading(true);
      if (Boolean(data?.id)) {
        updateCoupon({
          data: data,
          onFinish: (res, err) => {
            openLoading(false);
            if (res === false) {
              errorAction(res, err);
              return;
            }
            enqueueSnackbar("Successfully Updated in", { variant: "success" });
            history.push("/coupons");
          },
        });
      } else {
        createCoupon({
          data: data,
          onFinish: (res, err) => {
            openLoading(false);
            if (res === false) {
              errorAction(res, err);
              return;
            }
            enqueueSnackbar("Successfully added in", { variant: "success" });
            history.push("/coupons");
          },
        });
      }
    }
  };

  useEffect(() => {
    setData(couponInfo);
  }, [couponInfo]);
  return (
    <div>
      <Paper>
        <div
          className="p-4 flex justify-between items-center border-b border-white-gray"
          onClick={handleClickAdd}
        >
          <CustomText variant="h6" bold={600}>
            {Boolean(couponInfo?.id) ? "Update Coupon" : "Create New Coupon"}
          </CustomText>
        </div>
        <div className="p-4">
          <LabelControl
            label="COUPON NAME"
            control={
              <EditFormControl
                data={data}
                name="name"
                onChange={handleChange}
                size="small"
                fullWidth={true}
                placeholder="Black Friday 2022"
                isLabel={true}
                error={error}
              />
            }
          />
          <Grid container spacing={2}>
            <Grid item lg={3} md={3} sm={12} xs={12}>
              <div className="my-2">
                <LabelControl
                  label="COUPON DISCOUNT"
                  control={
                    <div className="flex items-start">
                      <EditFormControl
                        name="amount"
                        data={data}
                        onChange={handleChange}
                        type="number"
                        size="small"
                        error={error}
                      />
                      <EditFormControl
                        name="type"
                        className="flex-1"
                        data={data}
                        onChange={handleChange}
                        type="select"
                        options={[
                          { label: "Percentage (%)", id: "percent" },
                          { label: "Fixed ($)", id: "fixed" },
                        ]}
                        optionLabel={(option) => option.label}
                        size="small"
                      />
                    </div>
                  }
                />
              </div>
            </Grid>
            <Grid item lg={9} md={9} sm={12} xs={12}>
              <CouponDetailForm data={data} onChange={setData} ref={formRef} />
            </Grid>
          </Grid>
        </div>
      </Paper>
      <div className="flex items-center my-4">
        <Button variant="contained" color="secondary" onClick={handleClickAdd}>
          {Boolean(couponInfo?.id) ? "UPDATE COUPON" : "CREATE COUPON"}
        </Button>
        <Button
          className="mx-2"
          variant="outlined"
          color="secondary"
          onClick={() => history.goBack()}
        >
          CANCEL
        </Button>
      </div>
    </div>
  );
}
